// NOTE: this JS only deals with the non-mobile nav. The mobile nav
// is dealt with in mobile-nav.

const desktopSwapWidth  = 1024
let desktopVpWidth      = null
let allNavLevel1        = null

export function initialize() {
  inspectEnvironment()
}

export function inspectEnvironment() {
  desktopVpWidth = window.innerWidth
  if ((desktopVpWidth >= desktopSwapWidth)) {
    allNavLevel1 = document.querySelectorAll('[data-nav-level-1]')
    if (!allNavLevel1) {
      return
    }
    hideAllSubNavs()
    addListeners()
  }
}

export function hideAllSubNavs() {
  for (const el of allNavLevel1) {
	  el.checked = false;
	$(el).removeClass("opened");
  }
}

export function addListeners() {
  // for (const el of allNavLevel1) {
  //   el.parentElement.addEventListener('mouseenter', toggleSubNav, false)
  //   el.parentElement.addEventListener('mouseleave', hideAllSubNavs, false)
  // }
}

export function toggleSubNav(event) {
  let selectedNav   = event.target.firstChild
  let selectedNavID = selectedNav.id
  selectedNav.checked = true
  $(selectedNav).addClass("opened");
  for (const el of allNavLevel1) {
    if (selectedNavID !== el.id) {
      el.checked = false
    }
  }
}

$(document).on('click','[data-nav-level-1],[data-nav-level-2]',function(e) {
	var thisTarget = e.target;
	toggleMegaMenu(thisTarget);
});
$(document).on('keydown',function(e) {
    if(e.key === "Escape") {
		closeMegaMenu();
	}
});


function toggleMegaMenu(thisTarget,firstLinkFocus) {
	var firstLinkFocus = firstLinkFocus ? firstLinkFocus : false;
	if($(thisTarget).hasClass('opened')) {
		var windowWidth = $(window).width();
		if(windowWidth > 1024) {
			closeMegaMenu();
		} else {
			closeThisItem(thisTarget);
		}
	} else {
		var windowWidth = $(window).width();
		if(windowWidth > 1024) {
			$('[data-nav-level-1],[data-nav-level-2]').each(function() { $(this).removeClass("opened"); });
		}
		$(thisTarget).attr('aria-expanded','true').attr('aria-pressed','true').addClass("opened");
		if($(thisTarget).data('nav-level-1') !== 'undefined') {
			if(firstLinkFocus) {
				focusOnFirstLink(thisTarget);				
			}
		}
	}
}
function closeThisItem(thisTarget) {
	var currentlyOpen = thisTarget;
	$(currentlyOpen).removeClass("opened").attr('aria-expanded','false').attr('aria-pressed','false').focus();
}
function closeMegaMenu() {
	var currentlyOpen = $('[data-nav-level-1].opened');
	$('[data-nav-level-1],[data-nav-level-2]').each(function() { $(this).removeClass("opened"); });
	$(currentlyOpen).attr('aria-expanded','false').attr('aria-pressed','false').focus();
}
function focusOnFirstLink(thisTarget) {
	$(thisTarget).next('ul').find('a:first').focus();
}

export function makeSubmenuHeadlinesUnTabbable() {
	var windowWidth = $(window).width();
	if(windowWidth > 1024) {
		$('[data-nav-level-2]').each(function() {
			var thisInnerHtml = $(this).html();
			$(this).replaceWith('<div class="col-heading-desktop">'+thisInnerHtml+'</div>');
		});
	}
}
makeSubmenuHeadlinesUnTabbable();

//open mega menu on down key
$(document).on('focusin','[data-nav-level-1][aria-expanded="false"],.header__nav-list > li > a, .header__nav-list > li.search',function(e) {
	var thisTarget = e.target;
	$(this).bind('keydown',function(e) {
	    if(e.key === "ArrowDown") {
	    	closeMegaMenu();
			if($(thisTarget).attr('aria-haspopup') == 'true') {
				toggleMegaMenu(thisTarget,true);								
			} else {
				e.preventDefault();
			}
		}
	    if(e.key === "ArrowLeft") {
			moveMainNavFocusLeft(thisTarget);
		}
	    if(e.key === "ArrowRight") {
			moveMainNavFocusRight(thisTarget);
		}
	});
});

function moveMainNavFocusLeft(thisTarget) {
	var thisTarget = thisTarget;
	var parentLI = thisTarget.closest('li');
	var parentSiblingLI;
	parentSiblingLI = $(parentLI).prev('li');
	if($(parentLI).prev('li').length < 1) {
		var parentUl = $(parentLI).closest('ul');
		parentSiblingLI = $(parentUl).find('li:last');			
	}
	parentSiblingLI.find('a:first-child,button:first-child')[0].focus();

}

function moveMainNavFocusRight(thisTarget) {
	var thisTarget = thisTarget;
	var parentLI = thisTarget.closest('li');
	var parentSiblingLI;
	parentSiblingLI = $(parentLI).next('li');
	if($(parentLI).next('li').length < 1) {
		var parentUl = $(parentLI).closest('ul');
		parentSiblingLI = $(parentUl).find('li:first-child');			
	}
	parentSiblingLI.find('a:first-child,button:first-child')[0].focus();
}

$(document).on('focusin','[data-nav-level-1] + ul a',function(e) {
	var thisTarget = e.target;
	$(this).bind('keydown',function(e) {
		// console.log(e.key);
	    if(e.key === "ArrowDown") {
			e.preventDefault();
			moveSubNavFocusDown(thisTarget);
		}
	    if(e.key === "ArrowUp") {
			moveSubNavFocusUp(thisTarget);
		}
	    if(e.key === "ArrowLeft") {
			moveSubNavFocusLeft(thisTarget);
		}
	    if(e.key === "ArrowRight") {
			moveSubNavFocusRight(thisTarget);
		}
	});
});

function moveSubNavFocusDown(thisTarget) {
	var thisTarget = thisTarget;
	var parentLI = thisTarget.closest('li');
	var parentUL = thisTarget.closest('ul');
	var parentHighlight = thisTarget.closest('.highlights__item');
	if($(parentLI).hasClass('highlights') && parentHighlight) {
		var currentIndex = $(parentHighlight).index();
		$(parentUL).find('li:nth-of-type('+(currentIndex + 2)+')').find('ul:first-of-type > li:first-child > a:first-child').focus();
	} else {
		var parentSiblingLI;
		parentSiblingLI = $(parentLI).next('li');
		if($(parentLI).next('li').length < 1) {
			var grandparentLI = $(parentUL).closest('li');
			var grandparentUL = $(grandparentLI).closest('ul');
			var currentIndex = $(grandparentLI).index();
			if(grandparentUL.find('li.highlights').length > 0) { //has highlights menu
				parentSiblingLI = $(grandparentUL).find('li.highlights').find('.highlights__item:nth-of-type('+(currentIndex)+')');
			} else {
				parentSiblingLI = $(parentUL).find('li:first');
			}
		}
		parentSiblingLI.find('a')[0].focus();		
	}
}

function moveSubNavFocusUp(thisTarget) {
	var thisTarget = thisTarget;
	var parentLI = thisTarget.closest('li');
	var parentUL = thisTarget.closest('ul');
	var parentHighlight = thisTarget.closest('.highlights__item');
	if($(parentLI).hasClass('highlights') && parentHighlight) {
		var currentIndex = $(parentHighlight).index();
		$(parentUL).find('li:nth-of-type('+(currentIndex + 2)+')').find('ul:first-of-type > li:last > a:first-child').focus();
	} else {
		var parentSiblingLI;
		parentSiblingLI = $(parentLI).prev('li');
		if($(parentLI).prev('li').length < 1) {
			var grandparentLI = $(parentUL).closest('li');
			var grandparentUL = $(grandparentLI).closest('ul');
			var currentIndex = $(grandparentLI).index();
			if(grandparentUL.find('li.highlights').length > 0) { //has highlights menu
				parentSiblingLI = $(grandparentUL).find('li.highlights').find('.highlights__item:nth-of-type('+(currentIndex)+')');
			} else {
				parentSiblingLI = $(parentUL).find('li:last');
			}
		}
		parentSiblingLI.find('a')[0].focus();		
	}
}

function moveSubNavFocusRight(thisTarget) {
	var thisTarget = thisTarget;
	var parentLI = thisTarget.closest('li');
	var parentUL = thisTarget.closest('ul');
	var parentHighlight = thisTarget.closest('.highlights__item');
	if($(parentLI).hasClass('highlights') && parentHighlight) {
		if($(parentHighlight).next('div').length < 1) {
			$(parentLI).next('li').find('ul:first-of-type > li:first-child > a:first-child')[0].focus();
		} else {
			$(parentHighlight).next('div').find('a')[0].focus();
		}
	} else {
		var grandparentLI = $(parentUL).closest('li');
		var grandparentUL = $(grandparentLI).closest('ul');
		if($(grandparentLI).next('li').length < 1) {
			$(grandparentUL).find('li:first a')[0].focus();
		} else {
			$(grandparentLI).next('li').find('ul:first-of-type > li:first-child > a:first-child')[0].focus();			
		}
	}
}

function moveSubNavFocusLeft(thisTarget) {
	var thisTarget = thisTarget;
	var parentLI = thisTarget.closest('li');
	var parentUL = thisTarget.closest('ul');
	var parentHighlight = thisTarget.closest('.highlights__item');
	if($(parentLI).hasClass('highlights') && parentHighlight) {
		if($(parentHighlight).prev('div').length < 1) {
			$(parentUL).find('li:last-child > ul:first-of-type > li:first-child > a:first-child')[0].focus();
		} else {
			$(parentHighlight).prev('div').find('a')[0].focus();
		}
	} else {
		var grandparentLI = $(parentUL).closest('li');
		var grandparentUL = $(grandparentLI).closest('ul');
		if($(grandparentLI).prev('li').length < 1) {
			$(grandparentUL).find('li:last-child a')[0].focus();
		} else {
			$(grandparentLI).prev('li').find('a')[0].focus();
		}
	}
}
